import { ArrowUpOnSquareIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react';
import { apiCall } from '../../../api/Interactor';
import { numberFormat, numberFormatWithoutSymbol, showToast } from '../../../Utils';
import { useParams } from 'react-router-dom';
import { useAppState } from '../../../AppStateContext';
import { Tabs, Tab } from "../../Tabs";
import CreateSettlementDialog from "./CreateSettlementDialog";

export default function Setlement(props) {

  const { user, updateUser } = useAppState();
  let [totalSettlement, setTotalSettlement] = useState(0)

  let [profile, setProfile] = useState({
    bank: "",
    name: "",
    number: "",
  });

  const [headers, setHeaders] = useState([
    { label: 'Nomor Settlement', key: 'settlement_code' },
    { label: 'Tanggal Transaksi', key: 'settlement_date' }, // Updated to 'settlement_date' for clarity
    { label: 'Total Transaksi', key: 'total_amount' },
    { label: 'Status', key: 'status' }
  ]);

  // Dynamic rows for the table
  const [products, setProducts] = useState([]);

  // State to track the header checkbox (Select All)
  const [selectAll, setSelectAll] = useState(false);

  // Handle "Select All" checkbox change
  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setProducts(products.map(product => ({
      ...product,
      checked: !selectAll
    })));
  };

  // Handle individual row checkbox change
  const handleRowCheckboxChange = (id) => {
    const updatedProducts = products.map(product => {
      if (product.id === id) {
        return { ...product, checked: !product.checked };
      }
      return product;
    });
    setProducts(updatedProducts);
  };

  // Update the header checkbox state based on the row selection
  const allSelected = products.every(product => product.checked);
  const indeterminate = products.some(product => product.checked) && !allSelected;

  // Handle row edit
  const handleEdit = (id, newName) => {
    const updatedProducts = products.map(product => {
      if (product.id === id) {
        return { ...product, name: newName };
      }
      return product;
    });
    setProducts(updatedProducts);
  };

  const getProfilesApi = () => {
    apiCall(
      "GET", process.env.REACT_APP_USER_PROFILES,
      {},
      (response) => {
        console.log(response);
        let data = response.data.data;
        console.log("Profiles");
        console.log(data);
        if (data.length > 0) {
          let item = data[0];
          setProfile(prev => ({
            ...prev,
            id: item.id,
            bank: item.bank_name.split(" - ")[0],
            name: item.bank_name.split(" - ")[1],
            number: item.bank_account_number
          }));
          console.log("Profile");
          console.log(item);
        }
      },
      (message) => {
        showToast("Error", "Failed", message);
      }
    );
  };

  const getSettlementApi = () => {
    apiCall(
      "GET", process.env.REACT_APP_USER_SETTLEMENT,
      {},
      (response) => {
        let data = response.data.data.settlements;
        // Ensure each item has a 'checked' field set to false initially
        data = data.map(item => ({
          ...item,
          checked: false
        }));
        setProducts(data); // Directly set products here
      },
      (message) => {
        showToast("Error", "Failed", message);
      }
    );
  };


  const getDailyTransactionApi = () => {
    apiCall(
      "POST", process.env.REACT_APP_USER_DAILY_TRANSACTION,
      {},
      (response) => {
        let data = response.data.data.details;
        let total = 0;
        data.forEach(item => {
          total += item.total_payment;
        });
        setTotalSettlement(total);
      },
      (message) => {
        showToast("Error", "Failed", message);
      }
    );
  };


  useEffect(() => {
    getProfilesApi();
    getSettlementApi();
    getDailyTransactionApi();
  }, []);

  return (
    <div className='w-full bg-white rounded-2xl flex flex-col px-6 py-6'>
      <p className='text-lg my-4 text-left text-gray-800 font-semibold'>History Settlement</p>
      <div className='flex flex-row gap-4'>
        <div className='flex flex-1 rounded-lg border-2 flex-row justify-between items-center py-4'>
          <img src='ic-money-solid.svg' className='ml-6' />
          <div className='flex flex-col ml-6'>
            <p className='text-xs mt-4'>Total Transaksi</p>
            <p className='text-lg font-bold mt-1 mb-4'>Rp. {numberFormatWithoutSymbol(totalSettlement)}</p>
          </div>
          <CreateSettlementDialog />
        </div>

        <div className='flex flex-1 rounded-lg border-2 flex-row justify-between items-center'>
          <div className='flex flex-col ml-6'>
            <p className='text-xs mt-4'>Rekening Aktif</p>
            <p className='text-sm font-bold mt-3 mb-4 ml-12'>{profile.bank}</p>
          </div>
          <div className="flex flex-col ml-12 mr-6">
            <p className="text-sm font-bold mt-4 text-right">{profile.name}</p>
            <p className="text-sm font-bold mt-1 mb-4 text-right">{profile.number}</p>
          </div>
        </div>
      </div>
      <div className='flex-1 mt-4'>
        {/* <Tabs>
          <Tab label="Transaksi"> */}
        {products.length > 0 ? (

          <div className="relative overflow-x-auto mt-2 rounded-lg border-2 ">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500">
              <thead className="text-xs text-gray-700 uppercase">
                <tr>
                  {/* <th scope="col" className="p-4"> */}
                  {/* <div className="flex items-center"> */}
                  {/* Header checkbox with Select All logic */}
                  {/* <input
                          id="checkbox-all-search"
                          type="checkbox"
                          className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          checked={selectAll}
                          onChange={handleSelectAll}
                          ref={el => {
                            if (el) {
                              // Indeterminate state when some rows are selected
                              el.indeterminate = indeterminate;
                            }
                          }}
                        /> */}
                  {/* <label htmlFor="checkbox-all-search" className="sr-only">checkbox</label> */}
                  {/* </div> */}
                  {/* </th> */}
                  {headers.map((header, index) => (
                    <th key={header.key} scope="col" className="px-6 py-3">
                      {header.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {products.map((product) => (
                  <tr key={product.id} className="bg-white border-b hover:">
                    {/* <td className="w-4 p-4">
                        <div className="flex items-center"> */}
                    {/* Conditionally render checkbox */}
                    {/* {product.status !== 'Done' && (
                            <input
                              id={`checkbox-table-${product.id}`}
                              type="checkbox"
                              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                              checked={product.checked}
                              onChange={() => handleRowCheckboxChange(product.id)}
                            />
                          )} */}
                    {/* <label htmlFor={`checkbox-table-${product.id}`} className="sr-only">
                            checkbox
                          </label>
                        </div>
                      </td> */}
                    {headers.map((header) => (
                      <td key={header.key} className="px-6 py-4">
                        {header.key === 'status' ? (
                          product[header.key] === "Done" ? (
                            <div className='bg-[#66bb6a] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]'>
                              {product[header.key]}
                            </div>
                          ) : product[header.key] === "Pending" ? (
                            <div className='bg-[#ffa726] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]'>
                              {product[header.key]}
                            </div>
                          ) : (
                            <div className='font-semibold capitalize'>
                              {product[header.key]}
                            </div>
                          )
                        ) : header.key === 'total_amount' ? (
                          product[header.key]
                        ) : (
                          product[header.key] // Dynamically render product data based on the header key
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="flex flex-1 flex-col items-center justify-center w-full border border-gray-200 rounded-lg overflow-hidden text-center px-4 py-6 text-sm text-gray-600">
            <img src="/il-empty-nosettlement.png" alt="Empty State" className="w-[260px] mb-4" />
            <span className='text-[#898989] text-lg font-semibold mb-4'>Settlement</span>
            <span className='text-[#898989]'>
              Tidak ada data yang ditampilkan karena belum ada settlement dibuat,<br></br>
              silahkan buat settlement baru dengan klik tombol di atas.
            </span>
          </div>
        )}

        {/* </Tab>
          <Tab label="Penarikan Saldo">
          </Tab>
        </Tabs> */}
      </div>
    </div>
  );
}
